import type { AssistantPermissions, ReviewMode } from "./types"

export const REVIEW_MODES: { id: ReviewMode; label: string; hint: string }[] = [
  { id: "all", label: "Every change", hint: "The assistant asks before every write" },
  { id: "risky", label: "Risky changes", hint: "The assistant asks before updates, deletes and reverts" },
  { id: "optional", label: "Can auto-accept", hint: "May switch on auto-accept" },
]

export const NO_ASSISTANT: AssistantPermissions = { use: false, review: "all", configure: false }

// Returns null when the role has no assistant_permissions (column missing or never set)
export function parseAssistantPermissions(raw: unknown): AssistantPermissions | null {
  if (!raw || typeof raw !== "object") return null
  const r = raw as Record<string, unknown>
  return {
    use: r.use === true,
    review: r.review === "risky" || r.review === "optional" ? r.review : "all",
    configure: r.configure === true,
  }
}
